/* eslint-disable react-refresh/only-export-components */
import { DimeSeparator } from '@nudool/design-system';
import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

export const Route = createFileRoute('/design-system/separator')({
  component: SeparatorDocs,
});

function DocsSection({ title, children }: Readonly<{ title: string; children: React.ReactNode }>) {
  return (
    <section className="mb-10">
      <h2 className="mb-1 text-xl font-semibold">{title}</h2>
      <DimeSeparator className="mb-4" />
      {children}
    </section>
  );
}

function Preview({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-border bg-background p-6">
      {children}
    </div>
  );
}

function SeparatorDocs() {
  return (
    <div>
      <h1 className="mb-1 text-3xl font-bold">Separator</h1>
      <p className="mb-8 text-muted-foreground">
        A thin dividing line between content. Defaults to a horizontal orientation and is{' '}
        <code className="font-mono text-sm">decorative</code> (hidden from assistive tech) unless
        told otherwise.
      </p>

      <DocsSection title="Horizontal">
        <Preview>
          <div className="w-full">
            <p className="text-sm font-medium text-foreground">Inventory settings</p>
            <p className="text-sm text-muted-foreground">Configure how parts are tracked.</p>
            <DimeSeparator className="my-4" />
            <p className="text-sm font-medium text-foreground">Notifications</p>
            <p className="text-sm text-muted-foreground">Choose when to be alerted.</p>
          </div>
        </Preview>
        <p className="mt-3 text-sm text-muted-foreground">
          The default orientation spans the full width of its container.
        </p>
      </DocsSection>

      <DocsSection title="Vertical">
        <Preview>
          <div className="flex h-5 items-center gap-3 text-sm text-foreground">
            <span>Parts</span>
            <DimeSeparator orientation="vertical" />
            <span>Vendors</span>
            <DimeSeparator orientation="vertical" />
            <span>Orders</span>
          </div>
        </Preview>
        <p className="mt-3 text-sm text-muted-foreground">
          Pass <code className="font-mono">orientation="vertical"</code> inside a flex row. The
          divider uses <code className="font-mono">self-stretch</code> to fill the row's height —
          give the row a height (e.g. <code className="font-mono">h-5</code>).
        </p>
      </DocsSection>
    </div>
  );
}
